function WaitingConfirmationForgotPassword(props) {
    return (
        <div className="sign-page d-flex justify-content-center align-items-center vh-100 position-absolute inset-0 bg-white">
            <div className="wrap  d-flex align-items-center justify-content-center">
                <div className="d-flex align-items-center justify-content-center">
                    <div className="w-100 row justify-content-center p-4">
                        <div className="col-lg-3 pr-5">
                            <img src="/img/sending.png" className="w-100" />
                        </div>
                        <div className="judul w-100 mt-2 d-flex justify-content-center align-items-center">
                            <h3 className="fs-5 bold mb-1 text-center">Email verifikasi Terkirim</h3>
                        </div>
                        <div className="w-100 mt-2 d-flex justify-content-center align-items-center">
                            <span className="mb-1 d-flex text-center" style={{ 'fontSize': '15px' }}>Silakan cek email anda dan klik ubah kata sandi</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WaitingConfirmationForgotPassword;